import {
  FlexibleBlockProps,
  FlexibleBlockBrickIntegration,
  FlexibleBlockTemplateIntegration,
} from '@nx-frontend/shared/types';
import { getWrapperProps } from '@nx-frontend/shared/utils/blocks';
import { brickCommon } from './common';

export const getIntegrationBlockTemplate = (): FlexibleBlockProps<FlexibleBlockTemplateIntegration>[] => {
  const brickIntegration: FlexibleBlockBrickIntegration = {
    ...brickCommon,
    mainBrick: true,
    brickType: 'integration',
    brickName: 'Dynamic Table',
    title: 'Dynamic Table',
    provider: undefined,
    view: { type: 'table', mapping: [] },
    details: { show: true, title: 'Details', position: 'modal', mapping: [] },
    filter: { logic: 'AND', items: [], disabled: false },
    pagination: { type: 'paged', limit: 10 },
  };

  const block: FlexibleBlockProps<FlexibleBlockTemplateIntegration> = {
    title: 'Dynamic Table',
    wrapper: getWrapperProps('blank'),
    template: {
      type: 'integration',
      view: 'basic',
    },
    bricks: [{ ...brickIntegration, index: 0 }],
    className: [],
  };

  return [block];
};
